var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreadcrumbListStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70408 11.9544C2.41458 12.1128 2.08608 11.8352 2.14458 11.4808L2.76708 7.69694L0.124833 5.01223C-0.121916 4.76104 0.00633379 4.30186 0.337083 4.25226L4.01057 3.69548L5.64857 0.233992C5.79632 -0.0779974 6.19607 -0.0779974 6.34382 0.233992L7.98181 3.69548L11.6553 4.25226C11.9861 4.30186 12.1143 4.76104 11.8668 5.01223L9.22531 7.69694L9.84781 11.4808C9.90631 11.8352 9.57781 12.1128 9.28831 11.9544L5.99507 10.1497L2.70408 11.9544Z",
    fill: "#FF7D43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbListStartIcon);
export default __webpack_public_path__ + "static/media/breadcrumb-list-start-icon.189bd8141f5a9019722ddaf17ddb07de.svg";
export { ForwardRef as ReactComponent };